import React from 'react';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';
import {bool, func, string, arrayOf} from 'prop-types';
import BasicModal from 'components/common/BasicModal';

const StatusModal = props => {
  const header = <FormattedMessage id={props.success ? props.successHeaderKey : props.errorHeaderKey} />;
  const content = <p><FormattedMessage id={props.success ? props.successMessageKey : props.errorMessageKey} /></p>;

  const modalClassName = `${props.success ? 'success' : 'error'}-modal`;
  const specialType = classnames(props.size, modalClassName, 'fadeInUp animResponse', props.className);

  return (
    <BasicModal
      header={header}
      open={props.isOpen}
      onClose={props.onClose}
      specialType={specialType}>
      <React.Fragment>
        {content}
        {!props.success && (
          <ul>
            {props.errorKeys.map(key => <li><FormattedMessage id={key} /></li>)}
          </ul>
        )}
      </React.Fragment>
    </BasicModal>
  );
};

StatusModal.propTypes = {
  size: string,
  isOpen: bool,
  onClose: func.isRequired,
  success: bool,
  errorKeys: arrayOf(string),
  errorHeaderKey: string,
  errorMessageKey: string,
  successHeaderKey: string,
  successMessageKey: string
};

StatusModal.defaultProps = {
  size: 'small',
  errorKeys: []
};

export default StatusModal;



// WEBPACK FOOTER //
// ./public/components/common/StatusModal.jsx